import { render, staticRenderFns } from "./SelectedGroupDinamicField.vue?vue&type=template&id=71a71e6f"
import script from "./SelectedGroupDinamicField.vue?vue&type=script&lang=js"
export * from "./SelectedGroupDinamicField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports